import type { PublishedTmsEventStream } from "@storyboard/tms-event-contracts/base";
import { PUBLISHED_TMS_EVENT_STREAMS } from "@storyboard/tms-event-contracts/base";
import type { PublishedTmsEventKind } from "@storyboard/tms-event-contracts/tmsEventSubjects";
import { tmsEventStreamOf } from "@storyboard/tms-event-contracts/tmsEventSubjects";

/** Which stream serves an event, from the kind it states; a kind the client can hold is on a published stream. */
export function tmsEventStreamOfKind(kind: PublishedTmsEventKind): PublishedTmsEventStream {
  return tmsEventStreamOf(kind);
}

/**
 * Whether the client syncs each published stream.
 *
 * A record the compiler checks against the published vocabulary, so a stream the backend starts publishing fails to
 * compile here until someone decides whether this client reads it. `false` would be a decision, not an omission:
 * syncing a stream costs a bootstrap of every workspace's recent history and a poll a minute thereafter.
 */
const SYNCED_TMS_EVENT_STREAMS = {
  driver_event: true,
  route_event: true,
} as const satisfies Record<PublishedTmsEventStream, boolean>;

/** Every stream the backend publishes, whether or not this client syncs it; the debug table filters over these. */
export const ALL_TMS_EVENT_STREAMS: readonly PublishedTmsEventStream[] = PUBLISHED_TMS_EVENT_STREAMS;

/** Every stream the client bootstraps at workspace boot and walks on a ping. */
export const TMS_EVENT_STREAMS: readonly PublishedTmsEventStream[] = ALL_TMS_EVENT_STREAMS.filter(
  (stream) => SYNCED_TMS_EVENT_STREAMS[stream],
);
